import { FormAtylBase } from '../../form-atyl-base'

export class AtylAdresse extends FormAtylBase<string> {
	controlType = 'adresse';
	type: string
	options: any[] = [];

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
